export default __webpack_public_path__ + "static/media/kamivest_logo_default_center.6844fd2a.svg";